import React, { Fragment, PureComponent } from 'react';
import { Route, Switch } from 'react-router-dom';
import { withRouter } from 'react-router';
import { identify } from 'services/analytics';

// views
import About from 'views/About';
import Home from 'views/Home';
import Logo from 'components/Logo/Logo';
import NavBar from 'components/NavBar/NavBar';
import NavItem from 'components/NavBar/NavItem';
import NotFound from 'views/NotFound';
import TakeAction from 'views/TakeAction/TakeAction';
import Trumpism from 'views/Trumpism';

import { track } from 'services/analytics';
import { EVENTS, SOURCES } from 'services/analytics-constants';

class App extends PureComponent {
  componentDidMount() {
    identify();
  }

  trackHeaderButtonClick = ({ buttonName, path }) => {
    track(EVENTS.CLICK_HEADER_LINK, {
      buttonName,
      path,
      source: SOURCES.HEADER
    });
  };

  render() {
    return (
      <Fragment>
        <NavBar>
          <NavItem onClick={this.trackHeaderButtonClick} to="/">
            More from Today
          </NavItem>
          <NavItem onClick={this.trackHeaderButtonClick} to="/about">
            About
          </NavItem>
          <NavItem onClick={this.trackHeaderButtonClick} to="/take-action">
            Take Action
          </NavItem>
        </NavBar>
        <Logo />
        <Switch>
          <Route path="/" exact={true} component={Home} />
          <Route path="/about" component={About} />
          <Route path="/take-action" component={TakeAction} />
          <Route path="/not-found" component={NotFound} />
          <Route path="/:id" component={Trumpism} />
        </Switch>
      </Fragment>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.js